/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ActionType } from 'types'

import { useErrorAlert } from './useErrorAlert'
import { useSuccessAlert } from './useSuccessAlert'

interface IProps {
  backToSlug: string
  editPrefix?: string
  onSuccess?: any
  entityId: string
  entityName: string
  getEntityQuery: any
  createEntityMutation: any
  editEntityMutation: any
  deleteEntityMutation: any
}

const useCrudData = ({
  backToSlug,
  editPrefix,
  onSuccess,
  entityId,
  entityName,
  getEntityQuery,
  createEntityMutation,
  editEntityMutation,
  deleteEntityMutation,

}: IProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [addEntity, { isLoading: createLoading, isSuccess: createSuccess, error: createError, data: addResponseData }] =
    createEntityMutation()
  const [editEntity, { isLoading: editLoading, isSuccess: editSuccess, error: editError, data: editResponseData}] =
    editEntityMutation()
  const [deleteEntity, { isLoading: deleteLoading, isSuccess: deleteSuccess, error: deleteError }] =
    deleteEntityMutation()

  const { isLoading: entityLoading, data: entity } = getEntityQuery(entityId, { skip: !entityId || editLoading || editSuccess || deleteLoading || deleteSuccess })

  const isLoading = createLoading || editLoading || deleteLoading || entityLoading
  const error = createError || editError || deleteError
  const success = createSuccess || editSuccess || deleteSuccess


  useErrorAlert(error)
  useSuccessAlert(
    success
      ? t('alerts.' + (deleteSuccess ? 'entity-removed' : 'entity-saved'), {
          entity: entityName?.toUpperCase(),
        })
      : '',
  )

  useEffect(() => {
    if (success) {
      if(!deleteSuccess && onSuccess){
        onSuccess()
      }
      else{
        if(editPrefix && addResponseData && addResponseData.id)navigate(`${editPrefix}${addResponseData.id}/`)
        else if(editPrefix && editResponseData && editResponseData.id)navigate(`${editPrefix}${editResponseData.id}/`)
        else navigate(backToSlug)
      }
    }
  }, [success, navigate, addResponseData, editResponseData])

  const handleSubmit = (action: ActionType, id: string, data: any) => {
    if (action === 'add') {
      addEntity(data)
    }
    if (action === 'edit') {
      editEntity({ id, body: data })
    }
    if (action === 'delete') {
      deleteEntity(id)
    }
  }

  return {
    addResponseData,
    editResponseData,
    isLoading,
    entity,
    handleSubmit,
  }
}

export default useCrudData
